import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer"> 
      <div className="footer-top">
        <div className="footer-col">
          <h4>About Swastika Group</h4>
          <ul>
            <li><Link to="/about" style={{color: "black" , textDecoration :"none"}}>Overview</Link></li>
            <li><Link to="/vision" style={{color: "black" , textDecoration :"none"}}>Vision & Mission</Link></li>
            {/* <li><Link to="#" style={{color: "white" , textDecoration :"none"}}>Presence</Link></li> */}
            <li><Link to="/Corporate/MD" style={{color: "black" , textDecoration :"none"}}>MD Message </Link></li>

          
          </ul>
        </div>

        <div className="footer-col">
          <h4>Businesses</h4>
          <ul>
            <li><Link to="/service" style={{color: "black" , textDecoration :"none"}}>Services</Link></li>
            <li><Link to="./projects" style={{color: "black" , textDecoration :"none"}}>Projects</Link></li>
            <li><Link to="/why-us" style={{color: "black" , textDecoration :"none"}}>Why Us?</Link></li>
          
        
          </ul>
        </div>

        <div className="footer-col">
          <h4>Careers</h4>
          <ul>
            <li><Link to="/career" style={{color: "black" , textDecoration :"none"}}>Join Our Team</Link></li>
            <li><Link to="/contact" style={{color: "black" , textDecoration :"none"}}>Contact us</Link></li>

            <li></li>
            <li></li>
          
          </ul>
        </div>

        <div className="footer-col">
          <h4>Connect</h4>
          {/* <p><strong>View all Contacts</strong></p> */}
          <p>
            <strong style={{fontSize:"20px"}}>Swastika Infra Limited</strong><br />
            CIN – U51909RJ2019PLC065892 <br />
            Plot No. 14 & 15 , First Floor, Gajraj Apartment, Opp. Neelam Hotel, Motilal Atal Road, Jaipur – 302001, Rajasthan.
          </p>
          <p>
            Tel: 0141-4025773 <br />
            Email: 
            <span className="email">info@swastikainfra.com </span>
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>Powered by <span className="gap-link"><Link to="https://www.google.com/search?q=growaplan&oq=g&gs_lcrp=EgZjaHJvbWUqDwgAECMYJxjjAhiABBiKBTIPCAAQIxgnGOMCGIAEGIoFMhUIARAuGCcYrwEYxwEYgAQYigUYjgUyBggCEEUYOTIGCAMQRRg7MgYIBBBFGDwyBggFEEUYPDIGCAYQRRg8MgYIBxBFGDzSAQgyNTI1ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8">GROWAPLAN</Link></span> © 2026 Swastika Infra Limited. All rights reserved.</p>

        <div className="footer-links">
          {/* <span>Copyright & Terms</span> */}
          {/* <span>|</span> */}
          <Link  to="/privacy"  style={{color: "black" , textDecoration :"none"}}>Privacy Policy</Link>
          <span>|</span>

          <Link  to="/disclaimer"  style={{color: "black" , textDecoration :"none"}}>Disclaimer</Link>
        </div>

      <div className="footer-social">
  <span>Follow Us</span>

  {/* Instagram */}
  <a href="https://www.instagram.com/swastika.infra/" target="_blank" rel="noopener noreferrer">
    <div className="icon-circle">
      <svg viewBox="0 0 24 24" width="18" height="18">
        <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm10 2c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10zm-5 3a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6zm4.5-.9a1.1 1.1 0 100 2.2 1.1 1.1 0 000-2.2z"/>
      </svg>
    </div>
  </a>

  {/* Facebook */}
  <a href="https://www.facebook.com/photo/?fbid=122103954530821937&set=a.122103954656821937" target="_blank" rel="noopener noreferrer">
    <div className="icon-circle">
      <svg viewBox="0 0 24 24" width="18" height="18">
        <path d="M22.675 0h-21.35C.597 0 0 .597 0 1.325v21.351C0 23.403.597 24 1.325 24H12.82v-9.294H9.692V11.01h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.464.099 2.795.143v3.24h-1.918c-1.504 0-1.795.715-1.795 1.763v2.31h3.587l-.467 3.696h-3.12V24h6.116C23.403 24 24 23.403 24 22.676V1.325C24 .597 23.403 0 22.675 0z"/>
      </svg>
    </div>
  </a>

  {/* LinkedIn */}
  <a href="https://www.linkedin.com/in/swastika-infra-limited-68067a398/" target="_blank" rel="noopener noreferrer">
    <div className="icon-circle">
      <svg viewBox="0 0 24 24" width="18" height="18">
        <path d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM0 24h5V7H0v17zM7.5 7H12v2.5h.1C12.8 8.1 14.5 6.5 17.3 6.5 22.1 6.5 23 9.7 23 14V24h-5v-8.3c0-2-.04-4.6-2.8-4.6-2.8 0-3.2 2.2-3.2 4.4V24h-5V7z"/>
      </svg>
    </div>
  </a>

</div>


      </div>
    </footer>
  );
};

export default Footer;
